module.exports = __webpack_public_path__ + "fonts/FuturaNowText-Rg.3ad6eae8.ttf";